import { Controller } from "@hotwired/stimulus"

// Shows success feedback on button after form submission
// Can be triggered via:
// 1. Setting data-btn-feedback-triggered-value="true" (e.g., via turbo stream)
// 2. Successful turbo form submission (auto-triggers on turbo:submit-end with success)
export default class extends Controller {
  static targets = ["content", "success"]
  static values = {
    triggered: { type: Boolean, default: false },
    duration: { type: Number, default: 2500 }
  }

  connect() {
    // Listen for successful form submissions
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this)
    this.element.closest("form")?.addEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  disconnect() {
    this.element.closest("form")?.removeEventListener("turbo:submit-end", this.boundHandleSubmitEnd)
  }

  handleSubmitEnd(event) {
    // Trigger success feedback if submission was successful (2xx status)
    if (event.detail.success) {
      this.showSuccess()
    }
  }

  triggeredValueChanged(value) {
    if (value) {
      this.showSuccess()
    }
  }

  showSuccess() {
    this.contentTarget.classList.add("invisible")
    this.successTarget.classList.remove("invisible")

    setTimeout(() => {
      this.triggeredValue = false
      this.contentTarget.classList.remove("invisible")
      this.successTarget.classList.add("invisible")
    }, this.durationValue)
  }
}
